export default __webpack_public_path__ + "static/media/image1.c57ba1f3.webp";